import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { closeEditHelpInformation, loadBenefitsSettings, saveHelpInformation } from '../../../../core/store/benefits/benefits.actions';

@Component({
    selector: 'app-enrollment-edit-help-info',
    templateUrl: './enrollment-edit-help-info.component.html',
    styleUrls: ['./enrollment-edit-help-info.component.scss'],
    standalone: false
})
export class EnrollmentEditHelpInfoComponent extends BaseComponent implements OnInit {
  display: boolean = false;
  title: string = "Edit Help Information";
  disableButtons: boolean = false;

  contributionInfo: string = "";

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.subs.push(
      this.store.select(s => s.benefitsState.editingHelpInformation).subscribe(editing => {
        this.display = editing;
      }),
      this.store.select(s => s.benefitsState.benefitsSettings).subscribe(settings => {
        if (settings == null) {          
          return;
        }
        this.contributionInfo = settings.helpInformation || "";
      }),
    );   

    this.store.dispatch(loadBenefitsSettings());
  }

  closeModal() {
    this.store.dispatch(closeEditHelpInformation());
  }
  saveModal() {
    this.store.dispatch(saveHelpInformation({helpInfo: this.contributionInfo}));
  }
}
